var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "scholarList_content" }, [
    _c(
      "div",
      { staticClass: "scholar-list" },
      [
        _vm.personListData === null || _vm.personListData.length === 0
          ? _c("el-empty", { attrs: { description: "" } })
          : _vm._e(),
        _vm._l(_vm.personListData, function (scholarItem, index) {
          return _c("div", { key: index, staticClass: "person-view" }, [
            _c("div", { staticClass: "scholar-item pointer justify-between" }, [
              _c("div", { staticClass: "item-left" }, [
                _c(
                  "div",
                  {
                    staticClass: "flex",
                    on: {
                      click: function ($event) {
                        return _vm.goPersonalDetails(scholarItem.id)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "avatar-rate flex-column items-center",
                        staticStyle: { width: "90px", "flex-shrink": "0" },
                      },
                      [
                        _c("el-avatar", {
                          staticClass: "avatar",
                          attrs: { size: 80, src: scholarItem.avatar },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "scholar-text" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "max-width": "500px",
                          },
                        },
                        [
                          _c("span", { staticClass: "scholar-name" }, [
                            _vm._v(_vm._s(scholarItem.name)),
                          ]),
                          scholarItem.showTitle &&
                          scholarItem.showTitle.length !== 0
                            ? _c(
                                "div",
                                {
                                  staticClass: "org-content ellipsis",
                                  staticStyle: { "max-width": "300px" },
                                },
                                _vm._l(
                                  scholarItem.showTitle,
                                  function (title, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass:
                                          "field-content ellipsis name-title-box",
                                        attrs: { title: title },
                                      },
                                      [_vm._v(" " + _vm._s(title) + " ")]
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "infor-item" },
                        [
                          scholarItem.org_name
                            ? _c("div", { staticClass: "content-title" }, [
                                _vm._v(" 所在机构： "),
                              ])
                            : _vm._e(),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "light",
                                content: _vm.toChinese || scholarItem.org_name,
                                placement: "top",
                                enterable: false,
                                "popper-class": "translate-popper",
                              },
                            },
                            [
                              scholarItem.org_name
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "org-content pointer",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.toOrgDetail(scholarItem)
                                        },
                                        mouseenter: function ($event) {
                                          return _vm.enterToChineseFn(
                                            scholarItem.org_name
                                          )
                                        },
                                        mouseleave: _vm.leaveToChineseFn,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(scholarItem.org_name) + " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      ),
                      scholarItem.nativePlace
                        ? _c("div", { staticClass: "infor-item" }, [
                            _c("div", { staticClass: "content-title" }, [
                              _vm._v(" 籍贯： "),
                            ]),
                            scholarItem.nativePlace
                              ? _c(
                                  "div",
                                  { staticClass: "org-content pointer" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(scholarItem.nativePlace) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                      scholarItem.position
                        ? _c("div", { staticClass: "infor-item" }, [
                            _c("div", { staticClass: "content-title" }, [
                              _vm._v(" 职务： "),
                            ]),
                            scholarItem.position
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "org-content ellipsis",
                                    staticStyle: {
                                      "max-width": "120px",
                                      display: "block",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(scholarItem.position) + " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                      scholarItem.awardsText
                        ? _c("div", { staticClass: "infor-item" }, [
                            _c("div", { staticClass: "content-title" }, [
                              _vm._v(" 奖项： "),
                            ]),
                            scholarItem.awardsText
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "org-content",
                                    staticStyle: { "max-width": "190px" },
                                  },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "light",
                                          content: `${scholarItem.awardsText}\n${_vm.toChinese}`,
                                          placement: "top",
                                          enterable: false,
                                          "popper-class": "translate-popper",
                                        },
                                      },
                                      [
                                        _c("template", { slot: "content" }, [
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(scholarItem.awardsText)
                                            ),
                                          ]),
                                          _c("p", [
                                            _vm._v(_vm._s(_vm.toChinese)),
                                          ]),
                                        ]),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "field-content ellipsis",
                                            staticStyle: { color: "#333333" },
                                            on: {
                                              mouseenter: function ($event) {
                                                return _vm.enterToChineseFn(
                                                  scholarItem.awardsText
                                                )
                                              },
                                              mouseleave: _vm.leaveToChineseFn,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(scholarItem.awardsText) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                      scholarItem.innovation_index_l1 ||
                      scholarItem.publications_count ||
                      scholarItem.hindex ||
                      scholarItem.hIndex ||
                      scholarItem.citedby
                        ? _c("div", { staticClass: "infor-item" }, [
                            scholarItem.publications_count &&
                            scholarItem.publications_count !== "0"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "content-title",
                                    style:
                                      scholarItem.innovation_index_l1 &&
                                      scholarItem.innovation_index_l1 !== "0"
                                        ? "margin-left: 0px"
                                        : "",
                                  },
                                  [_vm._v(" 成果数： ")]
                                )
                              : _vm._e(),
                            scholarItem.publications_count &&
                            scholarItem.publications_count !== "0"
                              ? _c("div", { staticClass: "org-content" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(scholarItem.publications_count) +
                                      " "
                                  ),
                                ])
                              : _vm._e(),
                            (scholarItem.hindex &&
                              scholarItem.hindex !== "0") ||
                            (scholarItem.hIndex && scholarItem.hIndex !== "0")
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "content-title",
                                    style:
                                      scholarItem.publications_count &&
                                      scholarItem.publications_count !== "0"
                                        ? "margin-left: 34px"
                                        : "",
                                  },
                                  [_vm._v(" H指数： ")]
                                )
                              : _vm._e(),
                            scholarItem.hIndex && scholarItem.hIndex !== "0"
                              ? _c("div", { staticClass: "org-content" }, [
                                  _vm._v(
                                    " " + _vm._s(scholarItem.hIndex) + " "
                                  ),
                                ])
                              : _vm._e(),
                            scholarItem.hindex && scholarItem.hindex !== "0"
                              ? _c("div", { staticClass: "org-content" }, [
                                  _vm._v(
                                    " " + _vm._s(scholarItem.hindex) + " "
                                  ),
                                ])
                              : _vm._e(),
                            scholarItem.citedby && scholarItem.citedby !== "0"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "content-title",
                                    style:
                                      (scholarItem.publications_count &&
                                        scholarItem.publications_count !==
                                          "0") ||
                                      (scholarItem.hindex &&
                                        scholarItem.hindex !== "0")
                                        ? "margin-left: 34px"
                                        : "",
                                  },
                                  [_vm._v(" 引用数： ")]
                                )
                              : _vm._e(),
                            scholarItem.citedby && scholarItem.citedby !== "0"
                              ? _c("div", { staticClass: "org-content" }, [
                                  _vm._v(
                                    " " + _vm._s(scholarItem.citedby) + " "
                                  ),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "infoLine flex items-center",
                          staticStyle: { "margin-top": "10px" },
                        },
                        [
                          _c("span", { staticClass: "flex items-center" }, [
                            _vm._v("个人主页："),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass:
                                "pointer flex justify-center items-center",
                              staticStyle: {
                                width: "21px",
                                height: "21px",
                                "border-radius": "50%",
                                "background-color": "#3860F4",
                              },
                              style: {
                                backgroundColor: scholarItem.person_url
                                  ? "#3860F4"
                                  : "#999999",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.goInfoUrl(scholarItem.person_url)
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  width: "14px",
                                  height: "14px",
                                  src: require("@/assets/images/talent/boshi.png"),
                                  alt: "",
                                },
                              }),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex justify-center items-center pointer",
                              staticStyle: {
                                width: "21px",
                                height: "21px",
                                "border-radius": "50%",
                                "margin-left": "10px",
                              },
                              style: {
                                backgroundColor: scholarItem.googleAddress
                                  ? "#3860F4"
                                  : "#999999",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.goInfoUrl(
                                    scholarItem.googleAddress
                                  )
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  width: "14px",
                                  height: "14px",
                                  src: require("@/assets/images/talent/google.png"),
                                  alt: "",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
              _c(
                "div",
                {
                  staticClass: "flex-column items-center",
                  staticStyle: {
                    width: "100px",
                    "flex-shrink": "0",
                    "margin-top": "10px",
                    border: "1px solid transparent",
                  },
                },
                [
                  scholarItem.scholarReportVisible
                    ? _c(
                        "div",
                        {
                          staticClass: "load-button",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.getReport(
                                "scholar",
                                scholarItem.id,
                                scholarItem.name
                              )
                            },
                          },
                        },
                        [_vm._v(" 人才报告 ")]
                      )
                    : _vm._e(),
                  scholarItem.citationReportVisible
                    ? _c(
                        "div",
                        {
                          staticClass: "load-button",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.getReport(
                                "citation",
                                scholarItem.googleId,
                                scholarItem.name
                              )
                            },
                          },
                        },
                        [_vm._v(" 引文报告 ")]
                      )
                    : _vm._e(),
                ]
              ),
            ]),
            _c(
              "div",
              { staticClass: "flex honor-container" },
              _vm._l(scholarItem.showLeftList, function (honorItem, index) {
                return _c(
                  "el-tooltip",
                  {
                    key: index,
                    attrs: {
                      effect: "light",
                      content: _vm.toChinese || honorItem,
                      placement: "top",
                      enterable: false,
                      "popper-class": "translate-popper",
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "honor-item",
                        on: {
                          mouseenter: function ($event) {
                            return _vm.enterToChineseFn(honorItem)
                          },
                          mouseleave: _vm.leaveToChineseFn,
                        },
                      },
                      [_vm._v(" " + _vm._s(honorItem) + " ")]
                    ),
                  ]
                )
              }),
              1
            ),
            scholarItem.fields && scholarItem.fields.length !== 0
              ? _c(
                  "div",
                  { staticClass: "field" },
                  [
                    scholarItem.fields && scholarItem.fields.length !== 0
                      ? _c(
                          "div",
                          {
                            staticClass: "content-title",
                            staticStyle: { "min-width": "70px" },
                          },
                          [_vm._v(" 研究领域： ")]
                        )
                      : _vm._e(),
                    _vm._l(scholarItem.fields, function (field, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "field-content ellipsis" },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "light",
                                content: `${field.name}${_vm.toChinese}`,
                                placement: "top",
                                enterable: false,
                                "popper-class": "translate-popper",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.enterToChineseFn(field.name)
                                    },
                                    mouseleave: _vm.leaveToChineseFn,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(index === 0 ? "" : "；") +
                                      _vm._s(field.name)
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ])
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }